/*
* Preload all assets at the start and show the progress.
*/

import 'phaser'

export default class Preloader extends Phaser.Scene {

  constructor () {
    super({ key: 'preloader' });
  }

  preload () {
    this.width = this.sys.game.canvas.width;
    this.height = this.sys.game.canvas.height;
    this.centerX = this.width / 2;
    this.centerY = this.height / 2;

    // Loading
    this.load.image('background', 'src/img/background.png');
    this.load.image('bar', 'src/img/bar.png');
    this.load.image('particle', 'src/img/particle.png');
    this.load.image('piece', 'src/img/piece.png');
    this.load.image('ball', 'src/img/ball.png');
    this.load.image('muted', 'src/img/muted.png');
    this.load.image('unmuted', 'src/img/unmuted.png');
    this.load.image('profile', 'src/img/profile.png');
    this.load.image('screenshot', 'src/img/screenshot.png');
    this.load.image('y8ball0000', 'src/img/y8ball0000.png');
    this.load.image('y8ball0001', 'src/img/y8ball0001.png');
    this.load.image('y8ball0002', 'src/img/y8ball0002.png');
    this.load.image('y8ball0003', 'src/img/y8ball0003.png');
    this.load.image('y8ball0004', 'src/img/y8ball0004.png');
    this.load.image('y8ball0005', 'src/img/y8ball0005.png');
    this.load.image('y8ball0006', 'src/img/y8ball0006.png');
    this.load.image('y8ball0007', 'src/img/y8ball0007.png');
    this.load.image('y8ball0008', 'src/img/y8ball0008.png');
    this.load.image('y8ball0009', 'src/img/y8ball0009.png');
    this.load.image('y8ball0010', 'src/img/y8ball0010.png');
    this.load.image('y8ball0011', 'src/img/y8ball0011.png');
    this.load.image('y8ball0012', 'src/img/y8ball0012.png');
    this.load.image('y8ball0013', 'src/img/y8ball0013.png');
    this.load.image('y8ball0014', 'src/img/y8ball0014.png');
    this.load.image('y8ball0015', 'src/img/y8ball0015.png');
    this.load.image('y8ball0016', 'src/img/y8ball0016.png');
    this.load.image('y8ball0017', 'src/img/y8ball0017.png');
    this.load.image('y8ball0018', 'src/img/y8ball0018.png');
    this.load.image('y8ball0019', 'src/img/y8ball0019.png');
    //this.load.atlas('flood', 'src/atlas/blobs.png', 'src/atlas/blobs.json');
    this.load.audio('button', ['src/sound/button.mp3']);
    this.load.audio('music', ['src/sound/music.mp3', 'src/sound/music.ogg']);

    this.loadingText = this.add.text(this.centerX, this.centerY, 'Loading... ', { fontFamily: '"Roboto Condensed"' });
    this.load.on('progress', (value) => {
      this.loadingText.setText('loading.. ' + parseInt(value * 100) + '%');
    });

    this.load.on('complete', () => {
      this.loadingText.destroy();
      ID.gameBreak(() => {
        this.scene.start('game');
      })
      
    });
  }

  create() {
    
  }
}
